import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/orders',
    name: 'orders',
    component: () => import('../views/OrdersView.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue')
  },
  {
    path: '/daily-orders',
    name: 'dailyOrders',
    component: () => import('../views/DailyOrdersChartView.vue')
  },
  {
    path: '/daily-summary',
    name: 'dailySummary',
    component: () => import('../views/DailySummaryView.vue')
  },
  {
    path: '/products',
    name: 'products',
    component: () => import('../views/ProductsView.vue')
  },
  {
    path: '/expenses',
    name: 'expenses',
    component: () => import('../views/ExpensesView.vue')
  },
  {
    path: '/quotation',
    name: 'quotation',
    component: () => import('../views/QuotationView.vue')
  },
  {
    path: '/invoice',
    name: 'invoice',
    component: () => import('../views/InvoiceView.vue')
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../views/ProfileView.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/RegisterView.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// permission ids per route
const routePermissions = {
  '/orders':        5,
  '/daily-orders':  2,
  '/products':      3,
  '/daily-summary': 4,
  '/invoice':       null,
  '/quotation':     null,
  '/expenses':      null
}

router.beforeEach((to, from, next) => {
  const requiredPerm = routePermissions[to.path]
  if (requiredPerm === undefined || requiredPerm === null) return next()

  const user = JSON.parse(localStorage.getItem('user') || '{}')
  const permIds = (user?.permissions || []).map(p => p.id)

  if (permIds.includes(requiredPerm)) return next()

  // no permission — redirect to first permitted route
  const permittedRoutes = [
    { permId: 5, path: '/orders' },
    { permId: 2, path: '/daily-orders' },
    { permId: 3, path: '/products' },
    { permId: 4, path: '/daily-summary' }
  ]
  const first = permittedRoutes.find(r => permIds.includes(r.permId))
  next(first ? first.path : '/')
})

export default router
